import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '../../styles/breakpoints';

type PlaybackStartingTranslateContainerProps = {
	visible?: boolean;
	duration?: number;
	children: React.ReactNode;
};

const PlaybackStartingTranslateWrapper = styled.div<PlaybackStartingTranslateContainerProps>`
	overflow: hidden;
	height: 324px;
	margin-bottom: -125px;

	@media ${breakpoints.sm} {
		height: 252px;
		margin-bottom: -76px;
	}

	@media ${breakpoints.md} {
		height: 299px;
		margin-bottom: -86px;
	}
`;

const PlaybackStartingTranslateContent = styled.div<PlaybackStartingTranslateContainerProps>`
	transition: transform ${(props) => props.duration}ms ease-in;
	height: 199px;
	transform: translate3d(0, ${(props) => (props.visible ? 0 : '125px')}, 0);

	@media ${breakpoints.sm} {
		height: 176px;
		transform: translate3d(0, ${(props) => (props.visible ? 0 : '76px')}, 0);
	}

	@media ${breakpoints.md} {
		height: 213px;
		transform: translate3d(0, ${(props) => (props.visible ? 0 : '86px')}, 0);
	}
`;

const PlaybackStartingTranslateContainer: React.FC<PlaybackStartingTranslateContainerProps> = ({ visible, duration, children }) => {
	return (
		<PlaybackStartingTranslateWrapper visible={visible}>
			<PlaybackStartingTranslateContent visible={visible} duration={duration}>
				{children}
			</PlaybackStartingTranslateContent>
		</PlaybackStartingTranslateWrapper>
	);
};

export default PlaybackStartingTranslateContainer;
